import { ExchangeError } from '../../errors.js';
export const pidToTxData = (pid = '') => {
    if (pid.length === 0 || !/^([\dA-Fa-f]{2})*$/u.test(pid)) {
        throw new ExchangeError({
            message: `chfv2 pid must be a string and have an even number of hex digits to convert to uint8array`,
        });
    }
    const numBytes = pid.length / 2;
    const pidBytes = new Uint8Array(numBytes);
    for (let i = 0; i < numBytes; i++) {
        pidBytes[i] = parseInt(pid.slice(i * 2, i * 2 + 2), 16);
    }
    return pidBytes;
};
export const getUserTimezone = () => {
    try {
        const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        const offset = -new Date().getTimezoneOffset();
        const sign = offset >= 0 ? '+' : '-';
        const hours = String(Math.floor(Math.abs(offset) / 60)).padStart(2, '0');
        const minutes = String(Math.abs(offset) % 60).padStart(2, '0');
        return `GMT ${sign}${hours}:${minutes} (${timeZone.replace(/_/gu, ' ')})`;
    }
    catch { }
};
